<template>
  <el-form
    :model="user"
    ref="userForm"
    :rules="rules"
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <h4 class="form-title">User Information</h4>
    <el-row :gutter="15">
      <el-col :sm="12" :xs="24">
        <el-form-item label="Firstname" prop="first_name">
          <el-input v-model="user.first_name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12" :xs="24">
        <el-form-item label="Lastname" prop="last_name">
          <el-input v-model="user.last_name"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12" :xs="24">
        <el-form-item label="Email" prop="email">
          <el-input type="email" v-model="user.email"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12" :xs="24">
        <el-form-item label="Username" prop="username">
          <el-input v-model="user.username" :readonly="true"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="user.id">
      <el-col>
        <el-checkbox v-model="user.update_password"
          >Change password</el-checkbox
        >
      </el-col>
    </el-row>
    <el-row v-show="user.update_password || !user.id" :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Password" prop="password">
          <el-input
            type="password"
            v-model="user.password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="c_password">
          <el-input
            type="password"
            v-model="user.c_password"
            show-password
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-button class="mt-2" size="small" type="primary" @click="submit"
      >Update</el-button
    >
  </el-form>
</template>
<script>
import User from "@/models/User";
export default {
  name: "UserProfile",
  computed: {
    rules() {
      const rules = User.rules();
      if (this.user.update_password) {
        rules.password = [
          {
            required: true,
            message: "Password is required.",
            trigger: "blur"
          }
        ];
        rules.c_password = [
          {
            required: true,
            message: "Confirm Password is required.",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (value != this.user.password) {
                return callback(new Error("Password does not match!"));
              }
              callback();
            },
            trigger: "blur"
          }
        ];
      }
      return rules;
    }
  },
  data() {
    return {
      isLoading: false,
      user: new User()
    };
  },
  mounted() {
    var user = this.$store.getters["auth/user"];
    if (user.id) {
      this.isLoading = true;
      User.fetch(user.username).then(resp => {
        this.user = new User(resp);
        this.isLoading = false;
      });
    }
  },
  methods: {
    submit() {
      this.$confirm("Are you sure you want to your user information?", {
        confirmButtonText: "Yes"
      })
        .then(() => {
          this.$refs.userForm.validate(valid => {
            if (!valid) return false;

            this.isLoading = true;
            User.put(this.user).then(resp => {
              if (resp && resp.code == 200) {
                this.$notify({
                  type: "success",
                  message: "User information saved successfully.",
                  position: "bottom-right"
                });
                if (this.user.update_password) {
                  this.$store.dispatch("auth/logout").then(() => {
                    this.$router.push({ name: "login" });
                  });
                }
              }
              this.isLoading = false;
            });
          });
        })
        .catch(() => {});
    }
  }
};
</script>
